module.exports = __webpack_public_path__ + "img/homet.47c35ca9.png";